import {getNumber} from "./format";

export const setPreventEvent = (event, preventDefault = true) => {
	preventDefault && event.preventDefault();
	event.stopPropagation();
	event.returnValue = false;
	return false;
};

export const getKeyInfo = (event) => {
	const target = event.currentTarget;
	const keyCode = event.keyCode || event.which;
	const selectionLength = getNumber(target.selectionEnd) - getNumber(target.selectionStart);
	const isSelectionLeft = (target.selectionEnd == 0 || selectionLength == target.value.length);
	return {
		target : target,
		keyCode : keyCode,
		isCommand : (event.ctrlKey || event.altKey || event.shiftKey),
		isControl : (keyCode < 48 && keyCode != 32),
		isNumber : ((48 <= keyCode && keyCode <= 57) || (96 <= keyCode && keyCode <= 105)),
		isMinus : (isSelectionLeft && (keyCode == 109 || keyCode == 189)),
		isPoint : (!isSelectionLeft && (keyCode == 110 || keyCode == 190)),
		isZero : (isSelectionLeft && (keyCode == 48 || keyCode == 96)),
		isDash : (keyCode == 189 || keyCode == 109),
		isEnter : (keyCode == 13),
		selectionStart : target.selectionStart,
		selectionEnd : target.selectionEnd,
		selectionLength : selectionLength,
		value : target.value,
	}
};

export const getEventInfo = (event, id, prevent) => {
	const type = event.type;
	const isTouch = (type.indexOf("touch") > -1);
	if(isTouch) {
		if(prevent && event.cancelable)
			event.preventDefault();
		let e = event.changedTouches;
		let i = 0;
		if(id != undefined) {
			for(i = 0; i < e.length; i++)
				if(e[i].identifier == id) break;
			if(i == e.length) return;
		}
		e = event.changedTouches[i];
		event.x = event.clientX = e.clientX;
		event.y = event.clientY = e.clientY;
		event.id = e.identifier;
		event.object = document.elementFromPoint(e.clientX, e.clientY);
	} else {
		if(!(event.which == 1 || event.button == 0)) return;
		if(!event.x) event.x = event.clientX;
		if(!event.y) event.y = event.clientY;
		event.object = event.target || event.srcElement;
	}
	if((type == "mousedown" || type == "touchstart") && (!event.object)) return;
	return event;
};

export default {setPreventEvent, getKeyInfo, getEventInfo};